import React from 'react';
import { TURNSTILE_SITE_KEY } from '../../config';

// Cloudflare Turnstile bot check. Put it in a form, keep a ref to it and ask it for the token on submit:
//
//   this.turnstile = React.createRef();
//   <Turnstile ref={this.turnstile} />
//   const token = this.turnstile.current.getToken();   // '' until the visitor has passed the check
//   axios.post(url, { ..., turnstile_token: token })
//   this.turnstile.current.reset();                    // after every request: a token works only once
//
// The backend verifies the token (app_verify_turnstile() in surveystud-backend/turnstile.php).
const SCRIPT_URL = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=surveystudTurnstileLoaded';

let scriptPromise = null;
const loadScript = () => {
  if (window.turnstile) {
    return Promise.resolve(window.turnstile);
  }
  if (!scriptPromise) {
    scriptPromise = new Promise((resolve, reject) => {
      window.surveystudTurnstileLoaded = () => resolve(window.turnstile);
      const script = document.createElement('script');
      script.src = SCRIPT_URL;
      script.async = true;
      script.onerror = () => {
        scriptPromise = null;
        script.remove();
        reject(new Error('The Turnstile script could not be loaded'));
      };
      document.head.appendChild(script);
    });
  }
  return scriptPromise;
};

class Turnstile extends React.Component {
  container = React.createRef();

  widgetId = null;

  unmounted = false;

  componentDidMount() {
    loadScript()
      .then((turnstile) => {
        if (this.unmounted || !this.container.current) {
          return;
        }
        this.widgetId = turnstile.render(this.container.current, { sitekey: TURNSTILE_SITE_KEY });
      })
      .catch((error) => console.error('Turnstile:', error));
  }

  componentWillUnmount() {
    this.unmounted = true;
    if (this.widgetId !== null && window.turnstile) {
      window.turnstile.remove(this.widgetId);
    }
  }

  getToken() {
    return this.widgetId !== null && window.turnstile ? window.turnstile.getResponse(this.widgetId) || '' : '';
  }

  reset() {
    if (this.widgetId !== null && window.turnstile) {
      window.turnstile.reset(this.widgetId);
    }
  }

  render() {
    return <div ref={this.container} className="d-flex justify-content-center mb-3" />;
  }
}

export default Turnstile;
